<template>
    <div>
        <v-row>
            <v-col>
                <v-card class="pa-4 mb-4" :loading="remoteSupport.busy">
                    <v-card-title>
                        <label v-html="remoteSupport.title"/>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark v-on="on">{{ lastSearch }}</v-btn>
                            </template>
                            <v-list>
                                <v-list-item key="this" @click="thisSelected">
                                    <v-list-item-title>{{ thisMonth }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item key="last" @click="lastSelected">
                                    <v-list-item-title>{{ lastMonth }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item key="previous" @click="previousSelected">
                                    <v-list-item-title>{{ previousMonth }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                        <v-layout child-flex>
                            <v-data-table dense :headers="remoteSupport.table.headers" :items="remoteSupport.table.data" :loading="remoteSupport.busy" :loading-text="remoteSupport.table.loadingText" :items-per-page="remoteSupport.table.perPage"></v-data-table>
                        </v-layout>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="pa-4 mb-4">
                    <v-card-title>
                        <label v-html="instances.title"/>
                        <v-spacer></v-spacer>
                    </v-card-title>
                        <v-layout child-flex>
                            <v-data-table dense :headers="instances.table.headers" :items="instances.table.data" :loading="instances.busy" :loading-text="instances.table.loadingText" :items-per-page="instances.table.perPage" ></v-data-table>
                        </v-layout>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="pa-4 mb-4">
                    <v-card-title>
                        <label v-html="handshake.title"/>
                        <v-spacer></v-spacer>
                    </v-card-title>
                        <v-layout child-flex>
                            <v-data-table dense :headers="handshake.table.headers" :items="handshake.table.data" :loading="handshake.busy" :loading-text="handshake.table.loadingText" :items-per-page="handshake.table.perPage" fill-height></v-data-table>
                        </v-layout>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "Dashboard",
    data() {
        return {
            title: "Dashboard",
            fromDate: moment(),
            toDate: moment(),
            lastSearch: "This Month",
            thisMonth: "This",
            lastMonth: "Last",
            previousMonth: "Previous",
            remoteSupport: {
                title: "Remote Support",
                busy: false,
                table: {
                    loadingText: "Loading Remote Support...",
                    perPage: 5,
                    headers: [
                        { text: "Firm", value: "firmGUID" },
                        { text: "Firm", value: "firm" },
                        { text: "License", value: "licenseCode" },
                        { text: "Name", value: "name" },
                        { text: "Count", value: "count" },
                    ],
                    data: [],
                },
            },
            instances: {
                title: "Instances",
                busy: false,
                table: {
                    loadingText: "Loading Instances...",
                    perPage: 5,
                    headers: [
                        { text: "Firm", value: "firmGUID" },
                        { text: "License", value: "licenseCode" },
                        { text: "Name", value: "name" },
                        { text: "Date", value: "exported" },
                        { text: "Instances", value: "instances" },
                    ],
                    data: [],
                },
            },
            handshake: {
                title: "Handshake Failures",
                busy: false,
                table: {
                    loadingText: "Loading Handshake Failures...",
                    perPage: 5,
                    headers: [
                        { text: "Firm", value: "firmGUID" },
                        { text: "License", value: "licenseCode" },
                        { text: "Name", value: "name" },
                        { text: "Date", value: "exported" },
                        { text: "Type", value: "handshakeType" },
                        { text: "Count", value: "handshakeTypeCount" },
                    ],
                    data: [],
                },
            },
        };
    },
    mounted() {
        this.thisSelected();
    },
    methods: {
        setLastSearch() {
            this.lastSearch = moment(this.fromDate).format("MMM YYYY");
        },
        thisSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            this.setLastSearch();
            this.loadData();
        },
        lastSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth(), 0);
            this.setLastSearch();
            this.loadData();
        },
        previousSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth() - 2, 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth() - 1, 0);
            this.setLastSearch();
            this.loadData();
        },
        loadData() {
            this.loadRemoteSupportData();
            this.loadInstancesData();
            this.loadHandshakeData();

            const $this = this;
            this.$ga.event({
                eventCategory: "exceptions",
                eventAction: $this.lastSearch,
            });
        },
        loadRemoteSupportData() {
            this.remoteSupport.busy = true;
            this.remoteSupport.data = [];

            const query = `${moment(this.fromDate).format("YYYY-MM-DD")}/${moment(this.toDate).format("YYYY-MM-DD")}`;

            this.$http
                .get(`/api/stats/remote_support/${query}`)
                .then((response) => {
                    this.remoteSupport.table.data = response.data;
                    this.remoteSupport.busy = false;
                })
                .catch((err) => {
                    this.remoteSupport.busy = false;
                    this.$alert({ type: "error", title: "Remote Support Failed", message: err.response.data.exceptionMessage });
                });
        },
        loadInstancesData() {
            this.instances.busy = true;
            this.instances.data = [];

            const query = `${moment(this.fromDate).format("YYYY-MM-DD")}/${moment(this.toDate).format("YYYY-MM-DD")}`;

            this.$http
                .get(`/api/stats/instances/${query}`)
                .then((response) => {
                    this.instances.table.data = response.data;
                    this.instances.busy = false;
                })
                .catch((err) => {
                    this.instances.busy = false;
                    this.$alert({ type: "error", title: "Instances Failed", message: err.response.data.exceptionMessage });
                });
        },
        loadHandshakeData() {
            this.handshake.busy = true;
            this.handshake.data = [];

            const query = `${moment(this.fromDate).format("YYYY-MM-DD")}/${moment(this.toDate).format("YYYY-MM-DD")}`;

            this.$http
                .get(`/api/stats/handshake_count/${query}`)
                .then((response) => {
                    this.handshake.table.data = response.data;
                    this.handshake.busy = false;
                })
                .catch((err) => {
                    this.handshake.busy = false;
                    this.$alert({ type: "error", title: "Handshake Failed", message: err.response.data.exceptionMessage });
                });
        },
    },
};
</script>
